import React from 'react';

import { ConfirmDelete } from 'src/v2/features/profile/components/ConfirmDelete';

export const ProfileDeleteUserView = (props: any): JSX.Element => {
  return <ConfirmDelete {...props} />;
};
